export const translations = {
  da: {
    nav: {
      home: 'Forside',
      about: 'Om Jette',
      treatments: 'Behandlinger',
      prices: 'Priser',
      gallery: 'Galleri',
      contact: 'Kontakt',
      bookNow: 'Book tid'
    },
    hero: {
      title: 'Find ro, balance og velvære',
      subtitle: 'Hos Jette Keis Hansen bliver du mødt med næsten tre årtiers erfaring, nærvær og behandlinger, der tager udgangspunkt i netop din krop.',
      ctaBook: 'Book behandling',
      ctaAbout: 'Læs om Jette',
      badge: 'Over 29 års erfaring med massage'
    },
    whyJette: {
      tag: 'Hvorfor vælge Jette',
      title: 'Tilpassede behandlinger til krop og sind',
      intro: 'Kroppen husker alt og har sin egen unikke visdom. Igennem mere end 29 år har min filosofi været at skabe et trygt og uforstyrret rum, hvor din krop kan genfinde sin naturlige balance.',
      points: [
        {
          icon: 'fa-award',
          title: '29 års erfaring',
          desc: 'Dybdegående kompetencer inden for effektive behandlingsmetoder.'
        },
        {
          icon: 'fa-certificate',
          title: 'RAB godkendt behandler',
          desc: 'Jette er RAB godkendt - Anerkendt af sundhedsvæsenet med høje faglige kvalitetskrav. Har du en sundhedsforsikring, kan der udstedes bilag til refusion.'
        },
        {
          icon: 'fa-hand-holding-heart',
          title: 'Individuelle behandlinger',
          desc: 'Ingen standardiserede skabeloner. Hver session tilpasses din krops specifikke tilstand og behov.'
        },
        {
          icon: 'fa-spa',
          title: 'Helhedsorienteret tilgang',
          desc: 'Behandlingen kombinerer fysisk afspænding med dyb beroligelse af dit nervesystem.'
        },
        {
          icon: 'fa-shield-heart',
          title: 'Trygge rammer',
          desc: 'Nyd din behandling i det lyse og fredfyldte Salig-behandlingsfællesskab på Masnedøgade på Østerbro.'
        },
        {
          icon: 'fa-scale-balanced',
          title: 'Naturlig balance',
          desc: 'Fokus på at stimulere kroppens egen iboende evne til genopbygning og smertefrihed.'
        }
      ]
    },
    treatmentsOverview: {
      tag: 'Behandlingstyper',
      title: 'Skræddersyede behandlinger',
      subtitle: 'Udforsk mine primære behandlingsformer. Du er altid velkommen til at kontakte mig, hvis du er i tvivl om, hvad din krop har mest brug for.',
      viewAll: 'Se alle behandlinger',
      readMore: 'Læs mere om behandlingen'
    },
    aboutSnippet: {
      tag: 'Mød din behandler',
      title: 'Om Jette Keis Hansen',
      text1: 'Min rejse inden for massage startede for over 29 år siden. For mig er massagebehandling ikke blot en række greb, men en intuitiv og lyttende dialog med kroppens væv.',
      text2: 'Jeg kombinerer dybdegående fysiologisk viden med en holistisk opmærksomhed på hele mennesket. Uanset om du søger lindring for kroniske smerter, stressafspænding eller støtte under graviditet, er du i trygge hænder.',
      quote: '"Healing is the return of the memory of wholeness."',
      quoteAuthor: '– Deepak Chopra',
      cta: 'Læs Jettes fulde historie'
    },
    pricing: {
      tag: 'Prisoversigt',
      title: 'Gennemskuelige priser',
      subtitle: 'Alle behandlinger er baseret på tid og tilpasses din krops aktuelle behov.',
      timeBasedNote: 'Alle behandlinger er baseret på tid',
      times: [
        {
          duration: '60 minutter',
          price: '700 DKK',
          desc: 'Fokuseret behandling af specifikke problemområder som nakke, ryg eller skuldre.'
        },
        {
          duration: '75 minutter',
          price: '860 DKK',
          desc: 'Grundig behandling med god tid til både målrettet vævsarbejde og afspænding.'
        },
        {
          duration: '90 minutter',
          price: '1.000 DKK',
          desc: 'Dybdegående helkropsbehandling med tid til at kombinere flere teknikker.'
        },
        {
          duration: '120 minutter',
          price: '1.300 DKK',
          desc: 'Den ultimative fordybelse for maksimal afspænding og dyb kropslig nulstilling.'
        }
      ],
      packageDeal: {
        title: 'Klippekort – 5 behandlinger',
        badge: 'Spar 15%',
        text: 'Spar 15% ved køb af 5 behandlinger -- udløber efter 1 år (tilbudspris indtil 31. oktober)',
        desc: 'Gælder til alle behandlinger. Perfekt til et sammenhængende behandlingsforløb eller regelmæssig vedligeholdelse. Tilbudspris gælder indtil 31. oktober.'
      },
      rab: {
        title: 'RAB-godkendt behandler',
        badge: 'RAB Godkendt',
        text: 'Jette er RAB godkendt - Anerkendt af sundhedsvæsenet',
        desc: 'RAB (Registreret Alternativ Behandler) er en beskyttet titel og et kvalitetsstempel, der sikrer høje faglige krav, etik og uddannelsesstandarder.'
      },
      outCallNote: 'Ved udekørende behandlinger tillægges et ekstra gebyr (f.eks. + 300 DKK / efter aftale baseret på afstand).',
      paymentTitle: 'Betalingsmuligheder',
      paymentMethods: [
        { name: 'MobilePay', icon: 'fa-mobile-screen-button' },
        { name: 'Kortbetaling', icon: 'fa-credit-card' },
        { name: 'Kontant', icon: 'fa-money-bill-wave' }
      ]
    },
    location: {
      tag: 'Klinik & Lokation',
      title: 'Besøg klinikken på Østerbro',
      subtitle: 'Behandlingerne foregår i det rolige og æstetiske klinikfællesskab Salig i København Ø.',
      addressTitle: 'Klinikadresse',
      addressName: 'Salig',
      street: 'Masnedøgade 20, 2. sal',
      zipCity: '2100 København Ø',
      outCallTitle: 'Udekørende behandlinger',
      outCallText: 'Tilbydes direkte i eget hjem eller virksomhed i postnummer 2300 (Amager) samt efter nærmere aftale i Storkøbenhavn.',
      phoneTitle: 'Telefon',
      phoneVal: '81 98 37 07',
      emailTitle: 'E-mail',
      emailVal: 'MassagewithJette@gmail.com',
      hoursTitle: 'Åbningstider',
      hoursText: 'Åbent efter aftale mandag – lørdag.'
    },
    testimonials: {
      tag: 'Anmeldelser',
      title: 'Hvad siger klienterne?',
      subtitle: 'Læs oplevelser fra mænd og kvinder, der har modtaget behandlinger hos Jette.'
    },
    contactPage: {
      title: 'Kontakt & Tidsbestilling',
      subtitle: 'Udfyld formularen for at forespørge på en tid, eller ring direkte til Jette.',
      formName: 'Dit fulde navn',
      formPhone: 'Telefonnummer',
      formEmail: 'E-mailadresse',
      formTreatment: 'Ønsket behandling',
      formMessage: 'Beskriv dine ønsker, eventuelle skader eller foretrukne tidspunkter...',
      submitBtn: 'Send forespørgsel',
      submitting: 'Sender...',
      successMsg: 'Mange tak for din besked! Jette vender tilbage til dig hurtigst muligt.',
      errorMsg: 'Der opstod en fejl under afsendelsen. Prøv venligst igen eller ring på 81 98 37 07.'
    },
    footer: {
      aboutText: 'Professionel massage med over 29 års erfaring i hjertet af København.',
      quickLinks: 'Hurtige links',
      treatmentsLink: 'Behandlinger',
      contactInfo: 'Kontaktinformation',
      copyright: '© 2026 Massage with Jette. Alle rettigheder forbeholdes.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About Jette',
      treatments: 'Treatments',
      prices: 'Prices',
      gallery: 'Gallery',
      contact: 'Contact',
      bookNow: 'Book Now'
    },
    hero: {
      title: 'Find calm, balance and well-being',
      subtitle: 'With Jette Keis Hansen, you are met with nearly three decades of expertise, genuine presence, and bodywork tailored specifically to your body.',
      ctaBook: 'Book treatment',
      ctaAbout: 'About Jette',
      badge: 'Over 29 years of experience with massage'
    },
    whyJette: {
      tag: 'Why Choose Jette',
      title: 'Tailored treatments for body and mind',
      intro: 'The body remembers everything and carries its own natural wisdom. For over 29 years, my philosophy has been to create a peaceful, undisturbed sanctuary where your body can restore balance.',
      points: [
        {
          icon: 'fa-award',
          title: '29 years experience',
          desc: 'Deep expertise in effective treatment methods.'
        },
        {
          icon: 'fa-certificate',
          title: 'RAB Approved Therapist',
          desc: 'Jette er RAB godkendt - Anerkendt af sundhedsvæsenet, certified to healthcare standards. If you have health insurance, a receipt can be provided for reimbursement.'
        },
        {
          icon: 'fa-hand-holding-heart',
          title: 'Tailored treatments',
          desc: 'No generic formulas. Every session is custom adapted to your body’s unique condition.'
        },
        {
          icon: 'fa-spa',
          title: 'Holistic approach',
          desc: 'Combines targeted physical muscle release with deep soothing of your central nervous system.'
        },
        {
          icon: 'fa-shield-heart',
          title: 'Safe atmosphere',
          desc: 'Enjoy your treatment in the bright and tranquil Salig wellness space on Masnedøgade in Østerbro.'
        },
        {
          icon: 'fa-scale-balanced',
          title: 'Natural balance',
          desc: 'Focused on activating your body’s innate self-healing and pain-free vitality.'
        }
      ]
    },
    treatmentsOverview: {
      tag: 'Treatment Options',
      title: 'Tailored Massage Treatments',
      subtitle: 'Explore my specialized treatment techniques. You are always welcome to get in touch if you feel unsure which treatment best fits your needs.',
      viewAll: 'View all treatments',
      readMore: 'Read about treatment'
    },
    aboutSnippet: {
      tag: 'Meet your practitioner',
      title: 'About Jette Keis Hansen',
      text1: 'My journey in massage therapy started more than 29 years ago. To me, massage is not merely a set of techniques, but an intuitive, listening dialogue with the body’s tissue.',
      text2: 'I combine deep anatomical understanding with holistic care for the whole person. Whether you seek relief from chronic discomfort, stress release, or maternal care, you are in safe hands.',
      quote: '"Healing is the return of the memory of wholeness."',
      quoteAuthor: '– Deepak Chopra',
      cta: 'Read Jette’s full story'
    },
    pricing: {
      tag: 'Pricing List',
      title: 'Transparent Pricing',
      subtitle: 'All treatments are time-based and tailored to your body’s specific needs.',
      timeBasedNote: 'All treatments are time-based',
      times: [
        {
          duration: '60 minutes',
          price: '700 DKK',
          desc: 'Focused treatment targeting specific problem areas such as neck, back, or shoulders.'
        },
        {
          duration: '75 minutes',
          price: '860 DKK',
          desc: 'Thorough treatment allowing ample time for targeted tissue work and relaxation.'
        },
        {
          duration: '90 minutes',
          price: '1,000 DKK',
          desc: 'Deeper, unhurried full-body session combining multiple therapeutic modalities.'
        },
        {
          duration: '120 minutes',
          price: '1,300 DKK',
          desc: 'The ultimate deep session for full body reset, deep tissue release and profound calm.'
        }
      ],
      packageDeal: {
        title: 'Package Card – 5 Treatments',
        badge: 'Save 15%',
        text: 'Save 15% on 5 treatments -- expires after 1 year (special offer until October 31st)',
        desc: 'Save 15% when purchasing 5 sessions (valid for 1 year). Special offer until October 31st. Perfect for continuous therapy or routine wellness.'
      },
      rab: {
        title: 'RAB Approved Practitioner',
        badge: 'RAB Approved',
        text: 'Jette er RAB godkendt - Anerkendt af sundhedsvæsenet',
        desc: 'RAB (Registered Alternative Practitioner) is a protected title recognized by the Danish healthcare system ensuring high clinical standards.'
      },
      outCallNote: 'For out calls (mobile treatments), an additional fee applies (e.g. + 300 DKK / by agreement based on distance).',
      paymentTitle: 'Accepted Payment Methods',
      paymentMethods: [
        { name: 'MobilePay', icon: 'fa-mobile-screen-button' },
        { name: 'Credit / Debit Card', icon: 'fa-credit-card' },
        { name: 'Cash', icon: 'fa-money-bill-wave' }
      ]
    },
    location: {
      tag: 'Clinic & Location',
      title: 'Visit the Østerbro Clinic',
      subtitle: 'Treatments take place in the quiet, aesthetic Salig wellness space in Copenhagen Ø.',
      addressTitle: 'Clinic Address',
      addressName: 'Salig',
      street: 'Masnedøgade 20, 2nd floor',
      zipCity: '2100 Copenhagen Ø',
      outCallTitle: 'Mobile / Out-Call Treatments',
      outCallText: 'Offered directly in your home or office in zip code 2300 (Amager) and Greater Copenhagen by agreement.',
      phoneTitle: 'Phone',
      phoneVal: '81 98 37 07',
      emailTitle: 'Email',
      emailVal: 'MassagewithJette@gmail.com',
      hoursTitle: 'Opening Hours',
      hoursText: 'Open by appointment Monday through Saturday.'
    },
    testimonials: {
      tag: 'Testimonials',
      title: 'Client Experiences',
      subtitle: 'Read reviews from women and men who have experienced treatments with Jette.'
    },
    contactPage: {
      title: 'Contact & Booking Request',
      subtitle: 'Fill out the form below to request a session, or call Jette directly.',
      formName: 'Your full name',
      formPhone: 'Phone number',
      formEmail: 'Email address',
      formTreatment: 'Select treatment',
      formMessage: 'Describe your preferences, any injuries or preferred booking times...',
      submitBtn: 'Send booking request',
      submitting: 'Sending...',
      successMsg: 'Thank you for your message! Jette will contact you as soon as possible.',
      errorMsg: 'An error occurred while sending your request. Please try again or call 81 98 37 07.'
    },
    footer: {
      aboutText: 'Professional massage and holistic bodywork with over 29 years of experience in Copenhagen.',
      quickLinks: 'Quick Links',
      treatmentsLink: 'Treatments',
      contactInfo: 'Contact Information',
      copyright: '© 2026 Massage with Jette. All rights reserved.'
    }
  }
};
